<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'agent_index' }">代理商列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-top-15">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first">用户管理</el-tab-pane>
        <el-tab-pane label="省代" name="second">配置管理</el-tab-pane>
        <el-tab-pane label="市代" name="third">角色管理</el-tab-pane>
        <el-tab-pane label="区代" name="fourth">定时任务补偿</el-tab-pane>
      </el-tabs>
    </div>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-button type="danger" @click="discount" size="small">批量冻结</el-button>
        <el-button type="primary" @click="dialog_restore" size="small"
          >批量恢复</el-button
        >
      </el-card>
    </div>
    {{ tableData }}
    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>
      <el-table-column prop="username" label="头像" width="100"> </el-table-column>
      <el-table-column prop="username" label="代理商名/手机号" width="180">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.username"
            placement="top-start"
          >
            <span>{{ scope.row.username }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="代理等级/折扣">
        <template slot-scope="scope">
          {{ scope.row.level }}
        </template>
      </el-table-column>
      <el-table-column prop="price2" label="上级"> </el-table-column>
      <el-table-column prop="price3" label="采购金额"> </el-table-column>
      <el-table-column prop="stock_num" label="销售金额"> </el-table-column>
      <el-table-column prop="stock_num" label="统计"> </el-table-column>
      <el-table-column prop="agent" label="状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.agent"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="handleSwitch(scope.$index, scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="12">
              <el-button size="mini" @click="agentStat(scope.row)">代理统计</el-button>
            </el-col>

            <el-col :span="12">
              <el-button size="mini">信息编辑</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-button size="mini">采购订单</el-button>
            </el-col>

            <el-col :span="12">
              <el-button size="mini">销售订单</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-button size="mini" @click="setupStock(scope.$index, scope.row)"
                >下级会员</el-button
              >
            </el-col>

            <el-col :span="12">
              <el-button size="mini" @click="handleUpdate(scope.$index, scope.row)"
                >分销会员</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-button size="mini" @click="setupStock(scope.$index, scope.row)"
                >下级代理</el-button
              >
            </el-col>

            <el-col :span="12">
              <el-button size="mini" @click="handleUpdate(scope.$index, scope.row)"
                >冻结会员</el-button
              >
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialog_msg_visible"
      width="30%"
      :before-close="handleClose"
    >
      <span>此代理商将无法登陆后台并无法再获取订单利润，确认要冻结吗？</span>
      <span slot="footer">
        <el-button @click="dialog_msg_visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="dialog_msg_visible = false" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialog_restore_visible"
      width="30%"
      :before-close="handleClose"
    >
      <span>确认要恢复吗？</span>
      <span slot="footer">
        <el-button @click="dialog_restore_visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="dialog_restore_visible = false" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      agent: false,
      product_stock: {},
      dialog_msg_visible: false,
      dialog_restore_visible: false,
      page: 1,
    };
  },
  methods: {
    ...mapActions({
      agentUserIndexAction: "agentUserIndexAction",
    }),
    handleEdit(index, row) {
      console.log(index, row);
      this.tableData[index].editeFlag = true;
      //alert(row['id']);
      this.tableData[index] = row;
    },
    handleUpdate(index, row) {
      this.tableData[index].editeFlag = false;
      this.tableData[index] = row;
      //alert(JSON.stringify(this.tableData[index]));
      //alert(row['id']);
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    discount() {
      const len = this.multipleSelection.length;
      if (len == 0) {
        this.$message.error("请选择分销商");
      } else {
        this.dialog_msg_visible = true;
      }
    },
    dialog_restore() {
      const len = this.multipleSelection.length;
      if (len == 0) {
        this.$message.error("请选择分销商");
      } else {
        this.dialog_restore_visible = true;
      }
    },
    message_discount() {
      this.dialogFormVisible = true;
    },
    handleSwitch(index) {
      alert(JSON.stringify(this.tableData[index].agent));
    },
    setupStock(index, row) {
      this.dialogStoreVisible = true;
      this.product_stock = row;
      console.log(index, row);
    },
    agentStat(row) {
      const id = row.id;
      this.$router.push({
        name: "agent_stat",
        query: {
          id: id,
        },
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;
      console.log("tag", this.page);
      this.agentUserIndexAction({ page: page });
    },
  },
  created() {
    this.agentUserIndexAction({ page: this.page });
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.agentuser.result,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
